<div class="rounded-panel bg-light p-3 text-center border-0 mb-4" role="status">
	<strong class="d-block mb-4">
		{{totalCounts}} {{sourceField.charTypeID | charTypeName}} Records have data in this Field
	</strong>
	<div class="form-check">
		<input class="form-check-input" type="checkbox" [(ngModel)]="onlyShowDuplicates" />
		<label class="form-check-label ms-1">Only Show Duplicates</label>
	</div>
	<rl-text-input [(ngModel)]="fieldValue" [placeholder]="'Field Value'"></rl-text-input>
	<button class="btn btn-info btn-sm" type="button" (click)="validateUniqueness()"
		data-cy="validateUniquenessBtn">Validate Uniqueness</button>
</div>

@if(isLoading) {
	<div class="m-3 d-flex justify-content-center">
		<rl-loader></rl-loader>
	</div>
} @else {
	@if(dataSource) {
		<strong class="d-block pb-2">Found {{totalCounts}} {{sourceField.charTypeID | charTypeName}} Records with
			duplicate data:</strong>
		<rl-grid [dataSource]="dataSource" [layoutOptions]="layoutOptions"></rl-grid>
	}
}